import axios from "axios";
import type { UIModel } from "./types";
import { reactive, ref } from "vue";
import helpers from "@utils/helpers";

export const uiSettings = reactive({} as UIModel)
export const isInitExecuted = ref(false)

function init() {
    if (isInitExecuted.value) {
        return
    }

    isInitExecuted.value = true

    getUiPreferences()
        .then(function (response) {
            Object.assign(uiSettings, response.data);
        })
        .catch(helpers.handleError)
}

export function pinItem(url: string, name: string) {
    if (uiSettings.pinnedItems.find(x => x.url === url)) {
        return;
    }

    uiSettings.pinnedItems.push({ url, name });
    saveUiPreferences(uiSettings);
}

export function unpinItem(url: string) {
    const index = uiSettings.pinnedItems.findIndex(x => x.url === url);
    if (index !== -1) {
        uiSettings.pinnedItems.splice(index, 1);
        saveUiPreferences(uiSettings);
    }
}

export function saveUiPreferences(model: UIModel) {
    return axios.post('/api/common/user-preferences/ui', model);
}

export function getUiPreferences() {
    return axios.get<UIModel>('/api/common/user-preferences/ui');
}

export default {
    init,
    pinItem,
    unpinItem,
    getUiPreferences,
    saveUiPreferences,
}